/**
 * Contains Async Actions
 */

import pick from "lodash/pick";
import isEmpty from "lodash/isEmpty";
import { axiosInstance } from "@services/axios";
const { post } = axiosInstance;

import { jsonDataFormatter } from "@stadium/helpers/formatter";

import { SM_PROGRAM_ID } from "@constants/app-defaults";

import { getJsonCookie } from "@stadium/helpers/cookie";

const emptyObj = {};
const emptyArr = {};

const whiteListedUserProfileParams = [
  "allowCorporateBilled",
  "corporateAccountsAsOwner",
  "corporateAccountsAsMember",
  "currencyCode",
  "totalRewardPoints",
  "totalAvailableStoreCredit",
  "corporateBilled",
  "walletCurrencyId",
];
const formatAndUpdateStoredUser = (res) => (dispatch) => {
  const responseData = jsonDataFormatter(res);
  const { spreeUsers = emptyObj, spreeCorporateAccounts = emptyObj } = responseData || emptyObj;
  const extractedUserData = Object.values(spreeUsers)[0];
  const userData = pick(extractedUserData, whiteListedUserProfileParams);
  const payload = {
    ...userData,
    corporateAccounts: (extractedUserData?.corporateAccountsAsOwner || emptyArr).map(
      ({ id }) => spreeCorporateAccounts[id]
    ),
  };
  return payload;
};

export const fetchProfileData = () => async (dispatch) =>
  axiosInstance
    .get(`users/profile`, {
      program_id: SM_PROGRAM_ID,
    })
    .then((res) => {
      const user = dispatch(formatAndUpdateStoredUser(res));
      return user;
    })
    .catch((error) => {
      throw error;
    });

export const updateUserGeolocationParams = (countryName) => async (dispatch) => {
  const geoCookies = getJsonCookie("geo") || emptyObj;
  const { country_code, currency_code, ip_address, fallback } = geoCookies;

  if (!countryName && !isEmpty(geoCookies) && !fallback) {
    dispatch(updateUser({ user: { currency_code, country_code, ip_address } }));
  }
};

export const updateUser = (payload) => async (dispatch) =>
  axiosInstance
    .patch(`users/update`, payload)
    .then((res) => dispatch(formatAndUpdateStoredUser(res)));

export const verifyUserEmail = (payload) => async () =>
  post(`/users/verify_email`, payload)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
